import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import styles from './LanguageSwitcher.module.scss';
import classnames from 'classnames';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, t } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className={styles.languageSwitcher} ref={dropdownRef}>
      <div 
        className={classnames(styles.currentLanguage, isOpen ? styles.active : '')} 
        onClick={toggleDropdown}
      >
        {language.toUpperCase()}
      </div>
      
      {isOpen && (
        <ul className={styles.dropdown}>
          <li 
            className={classnames(styles.option, language === 'ru' ? styles.active : '')}
            onClick={() => {
              setLanguage('ru');
              setIsOpen(false);
            }}
          >
            Русский язык
          </li>
          <li 
            className={classnames(styles.option, language === 'en' ? styles.active : '')}
            onClick={() => {
              setLanguage('en');
              setIsOpen(false);
            }}
          >
            English language
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher; 